<script lang="ts">
import { Tooltip as TooltipPrimitive } from "bits-ui";
import { cn } from "$lib/utils.ts";
import TooltipPortal from "./tooltip-portal.svelte";

let {
  ref = $bindable(null),
  class: className,
  sideOffset = 4,
  children,
  ...restProps
}: TooltipPrimitive.ContentProps = $props();
</script>

<TooltipPortal>
  <TooltipPrimitive.Content
    bind:ref
    data-slot="tooltip-content"
    {sideOffset}
    class={cn(
      "bg-foreground text-background z-50 w-fit max-w-xs origin-(--bits-tooltip-content-transform-origin) rounded-md px-3 py-1.5 text-xs",
      className,
    )}
    {...restProps}
  >
    {@render children?.()}
    <TooltipPrimitive.Arrow class="fill-foreground" />
  </TooltipPrimitive.Content>
</TooltipPortal>
